
export default [
  {
    path: '/admin/loan-write-offs',
    name: 'loan-write-off',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-write-off')
  }
]
